module.exports = __webpack_public_path__ + "static/media/check.37c851ea.svg";